import { render, staticRenderFns } from "./notification-view-modal.vue?vue&type=template&id=579b9a0e&"
import script from "./notification-view-modal.vue?vue&type=script&lang=js&"
export * from "./notification-view-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog})
